<script setup lang="ts">
import type { ComboboxAnchorProps } from 'reka-ui'
import { ComboboxAnchor, useForwardProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

import { cn } from '../../../lib/utils'

const properties = defineProps<ComboboxAnchorProps & { class?: HTMLAttributes['class'] }>()

const delegatedProperties = computed(() => {
  const { class: _, ...delegated } = properties

  return delegated
})

const forwarded = useForwardProps(delegatedProperties)
</script>

<template>
  <ComboboxAnchor v-bind="forwarded" :class="cn('atabix-combobox-anchor', properties.class)">
    <slot />
  </ComboboxAnchor>
</template>

<style lang="scss" scoped>
.atabix-combobox-anchor {
  @apply w-full;
  @apply grid;
  grid-template-columns: 1fr auto;
  @apply items-center;
  @apply justify-start;
  @apply border;
  @apply border-border;
  @apply rounded-md;
  @apply min-h-10;
  @apply px-3;
  @apply py-2;
}
</style>
